import Button from './Button';

const BuildingInfo = ({ title, type, imagePath, action1_function, action1_title, action2_function, action2_title, both_used, none_used, button3_used, action3_title, action3_function, button4_used, action4_title, action4_function }) => {
  return (
    <div className="flex justify-between items-center gap-4 max-500:flex-col max-500:items-start">
      <div className="flex items-center">
        <img
          src={imagePath}
          alt={title}
          width={96}
          height={96}
          className="mr-[20px] rounded-full aspect-square"
        />

        <div>
          <h2 className="text-base font-medium text-[var(--arsenic)]">
            {title}
          </h2>
          <p className="text-[var(--electric-blue)]">{type}</p>
        </div>
      </div>

      <div className="flex justify-end max-1024:flex-col gap-[5px] max-500:flex-row max-500:w-full">
      {button3_used === 'tak' && ( <Button className="max-500:w-1/2" onClick={action3_function}>{action3_title}</Button> ) }
      {none_used === 'tak' ? ( <></>) : ( <Button className="max-500:w-1/2" onClick={action1_function}>{action1_title}</Button> ) }


{both_used === 'tak' && (
  <Button variant="bordered" onClick={action2_function} className="min-w-[150px] max-500:w-1/2">
    {action2_title}
  </Button>
)}
{button4_used === 'tak' && (
  <Button variant="bordered" onClick={action4_function} className="min-w-[150px] max-500:w-1/2">
    {action4_title}
  </Button>
)}
      </div>
    </div>
  );
};

export default BuildingInfo;
